export default {
    props: {
        chartAreaBackground: {
            type: String,
            kComposite: 'chartArea.background'
        }, 
        chartAreaOpacity: {
            type: Number,
            kComposite: 'chartArea.opacity'
        }, 
        chartAreaBorderColor: {
            type: String,
            kComposite: 'chartArea.border.color'
        }, 
        chartAreaBorderDashType: {
            type: String,
            kComposite: 'chartArea.border.dashType'
        }, 
        chartAreaBorderWidth: {
            type: Number,
            kComposite: 'chartArea.border.width'
        }, 
        chartAreaHeight: {
            type: Number,
            kComposite: 'chartArea.height'
        }, 
        chartAreaMargin: {
            type: Number | Object,
            kComposite: 'chartArea.margin'
        }, 
        chartAreaWidth: {
            type: Number,
            kComposite: 'chartArea.width'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoSparkline/ChartArea.js